export default __webpack_public_path__ + "static/media/warren2.a545ec32.jpg";